// Alert system types for portfolio monitoring

export type AlertType = 'info' | 'warning' | 'urgent' | 'success';

export type AlertCategory =
  | 'property_value'
  | 'rental_yield'
  | 'cash_flow'
  | 'expenses'
  | 'market_news'
  | 'general'
  | 'rent_increase'
  | 'council_rates_due'
  | 'water_rates_due'
  | 'loan_review'
  | 'fire_cert_expiry'
  | 'pool_cert_expiry'
  | 'bond_lodgement'
  | 'strata_agm';

export interface Alert {
  id: string;
  type: AlertType;
  category: AlertCategory;
  title: string;
  message: string;
  timestamp: Date;
  propertyId?: string; // Optional: link to specific property
  propertyAddress?: string; // For display purposes
  isRead: boolean;
  isDismissed: boolean;
  metadata?: {
    oldValue?: number;
    newValue?: number;
    changePercentage?: number;
    threshold?: number;
    [key: string]: any;
  };
}

export interface AlertPreferences {
  enabled: boolean;
  categories: {
    property_value: {
      enabled: boolean;
      thresholdPercentage: number; // Alert if value changes by this %
    };
    rental_yield: {
      enabled: boolean;
      thresholdPercentage: number; // Alert if yield drops below this %
    };
    cash_flow: {
      enabled: boolean;
      alertOnNegative: boolean;
    };
    expenses: {
      enabled: boolean;
      thresholdPercentage: number; // Alert if expenses increase by this %
    };
    market_news: {
      enabled: boolean;
    };
    general: {
      enabled: boolean;
    };
  };
}

export const DEFAULT_ALERT_PREFERENCES: AlertPreferences = {
  enabled: true,
  categories: {
    property_value: {
      enabled: false, // Disabled by default - can be enabled in settings
      thresholdPercentage: 5, // Alert on 5% change
    },
    rental_yield: {
      enabled: false, // Disabled by default - can be enabled in settings
      thresholdPercentage: 4, // Alert if yield drops below 4%
    },
    cash_flow: {
      enabled: false, // Disabled by default - can be enabled in settings
      alertOnNegative: true,
    },
    expenses: {
      enabled: false, // Disabled by default - can be enabled in settings
      thresholdPercentage: 15, // Alert on 15% increase
    },
    market_news: {
      enabled: true,
    },
    general: {
      enabled: true,
    },
  },
};
